// frontend/src/tour/steps/products-services.steps.js
// Products & Services catalog tour.

function normalizeRole(role) {
  if (!role) return "Sales Rep";
  const roleLower = role.toLowerCase();
  if (roleLower.includes("admin")) return "Admin";
  if (roleLower.includes("director")) return "Admin";
  if (roleLower.includes("manager")) return "Manager";
  return "Sales Rep";
}

export const PRODUCTS_SERVICES_TOUR_STEPS = (role) => {
  const normalizedRole = normalizeRole(role);
  const steps = [
    {
      id: "products-services-welcome",
      selector: "body",
      placement: "center",
      copy: {
        Admin: {
          title: "Products & Services",
          content:
            "Manage your company's catalog here. Add products, services, monthly charges, and discounts. Use the tabs to filter by type and the table to edit or delete items.",
        },
        Manager: {
          title: "Products & Services",
          content:
            "This page lets you manage your products and services catalog. Use the tabs to filter and the Add button to create new items.",
        },
        "Sales Rep": {
          title: "Products & Services",
          content:
            "View and manage your company's products and services catalog here.",
        },
      },
    },
    {
      id: "products-services-add",
      selector: '[data-tour="products-services-add"]',
      placement: "bottom",
      copy: {
        Admin: {
          title: "Add Product/Service",
          content:
            "Click here to add a new product or service. You can set name, category, price, SKU, and type (product, service, monthly charge, or discount).",
        },
        Manager: {
          title: "Add Product/Service",
          content:
            "Use this button to add new items to your catalog. Choose the type and fill in the details in the dialog.",
        },
        "Sales Rep": {
          title: "Add Product/Service",
          content:
            "Click here to add a new product or service to the catalog.",
        },
      },
    },
    {
      id: "products-services-tabs",
      selector: '[data-tour="products-services-tabs"]',
      placement: "bottom",
      copy: {
        Admin: {
          title: "Filter by Type",
          content:
            "Use these tabs to filter the list: All, Products, Services, Monthly Charges, or Discounts. This helps you focus on one type at a time.",
        },
        Manager: {
          title: "Filter by Type",
          content:
            "Switch between All, Products, Services, Monthly Charges, and Discounts to view or manage items by type.",
        },
        "Sales Rep": {
          title: "Filter by Type",
          content:
            "Use the tabs to filter the catalog by Products, Services, Monthly Charges, or Discounts.",
        },
      },
    },
    {
      id: "products-services-table",
      selector: '[data-tour="products-services-table"]',
      placement: "top",
      copy: {
        Admin: {
          title: "Catalog Table",
          content:
            "This table lists all items. You can edit or delete from the Actions column. When you add a new item, it appears here.",
        },
        Manager: {
          title: "Catalog Table",
          content:
            "All your products and services appear here. Use the Actions column to edit or delete items.",
        },
        "Sales Rep": {
          title: "Catalog Table",
          content:
            "The catalog is listed here. Use Actions to edit or delete items.",
        },
      },
    },
  ];
  return steps.map((step) => {
    const roleCopy = step.copy[normalizedRole] || step.copy["Sales Rep"];
    return {
      selector: step.selector,
      placement: step.placement,
      title: roleCopy.title,
      content: roleCopy.content,
    };
  });
};

/**
 * Versioned "new only" tour for Products & Services.
 * Add steps here when you ship new features; bump the key (e.g. v1_7_products_services_new_complete) when you add more.
 */
export const PRODUCTS_SERVICES_NEW_STEPS = () => [];
